import React, { useCallback, useState } from 'react'
import Link from '@material-ui/core/Link'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { CLOUDINARY_NAME } from '../../../containers/CreateACard'
import { Image, Transformation } from 'cloudinary-react'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import GreetingCardImageModal from './GreetingCardImageModal'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    infoList: {
        listStylePosition: 'outside',
        padding: '0',
        paddingLeft: '1em',
        fontSize: '0.95rem',
        '& li': {
            marginBottom: '0.5rem',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: '1rem',
        },
    },
    rewardCardRow: {
        display: 'flex',
        alignItems: 'flex-start',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: '1.1rem',
        },
        marginTop: '1.2rem',
    },
    linkText: {
        fontWeight: 'bold',
        color: theme.palette.secondary.main,
        textDecoration: 'underline',
    },
    rewardCardRowLinkText: {
        color: theme.palette.secondary.main,
        textDecoration: 'underline',
    },
    greetingCardImage: {
        margin: '0 auto',
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
            margin: 0,
        },
    },
    exampleButton: {
        marginTop: '1em',
        marginBottom: '2em',
        textTransform: 'none',
        width: '70%',
        color: 'rgb(0,92,89)',
        borderColor: 'rgb(0,92,89)',
        borderWidth: '2px',
        fontWeight: 'bold',
    },
    exampleLink: {
        display: 'flex',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        '& a:first-child': {
            fontWeight: 'bold',
            color: '#000',
        },
    },
    businessLogoLink: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginTop: '1em',
        marginBottom: '1em',
        '& a:first-child': {
            fontWeight: 'bold',
            color: '#000',
        },
    },
    businessLogoText: {
        marginBottom: '1rem',
        width: '65%',
    },
    chevronRight: {
        color: theme.palette.primary.main,
    },
}))

const IntroContent = ({ baseUrl, isVirtual }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [modalIsOpen, setModalIsOpen] = useState(false)
    return (
        <>
            <GreetingCardImageModal
                modalIsOpen={modalIsOpen}
                closeModal={() => {
                    setModalIsOpen(false)
                }}
            />
        </>
    )
}

export default IntroContent
